import { toast } from "react-toastify"

import { REQ } from "../../constants/api/requests"
import { IResponse } from "../../constants/interfaces"
import useApi from "../../util/api"

import { IReferrals, ReferralsCodesTableResponse, ReferralsTableResponse, ReferrersTableResponse } from "./type"

class ReferralsService implements IReferrals {
  public async getReferrersTable(
    page: number,
    pageSize: number,
    id: number | undefined,
    filters: { q: string; createdAt: (Date | null)[] } | undefined,
    sortRow?: string,
    sortOrder?: string
  ): Promise<ReferrersTableResponse | void> {
    try {
      const params = { page, pageSize, sortRow, sortOrder }
      const { data } = await useApi.get<IResponse<ReferrersTableResponse>>(REQ.ADMIN_DASHBOARD.REFERRALS.LIST, { params })
      if (data?.success) {
        return data?.response
      }
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to fetch referrers")
    }
  }

  public async getReferralsCodesTable(
    page: number,
    pageSize: number,
    id: string,
    filters: { q: string; createdAt: (Date | null)[] } | undefined,
    sortRow?: string,
    sortOrder?: string
  ): Promise<ReferralsCodesTableResponse | void> {
    try {
      if (!id) throw new Error("Referral code is missing")
      const params = { page, pageSize, sortRow, sortOrder }
      const { data } = await useApi.get<IResponse<ReferralsCodesTableResponse>>(
        REQ.ADMIN_DASHBOARD.REFERRALS.REFERRALS_CODES_LIST.replace(":referrerId", id),
        { params }
      )
      if (data?.success) {
        return data?.response
      }
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to fetch referrals")
    }
  }

  public async getReferralsTable(
    page: number,
    pageSize: number,
    id: string,
    filters: { q: string; createdAt: (Date | null)[] } | undefined,
    sortRow?: string,
    sortOrder?: string
  ): Promise<ReferralsTableResponse | void> {
    try {
      if (!id) throw new Error("Referral code is missing")
      const params = { page, pageSize, sortRow, sortOrder }
      const { data } = await useApi.get<IResponse<ReferralsTableResponse>>(
        REQ.ADMIN_DASHBOARD.REFERRALS.REFERRALS_LIST.replace(":code", id),
        { params }
      )
      if (data?.success) {
        return data?.response
      }
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to fetch referrals")
    }
  }

  public async updateAllAffiliatesBulk(payload: any) {
    const { data } = await useApi.patch<IResponse<any>>(REQ.ADMIN_DASHBOARD.REFERRALS.UPDATE_ALL_AFFILIATES, payload)
    if (data?.success) return data?.response
  }
}

export const referralsService = new ReferralsService()
